module.exports = __webpack_public_path__ + "img/logo_white.03f8394f.png";